export default __webpack_public_path__ + "static/media/bg-masthead-3-640w.88618d36.jpg";